export { default as UpdateClassifyModal } from './UpdateClassify'
export { default as UpdateLabelModal } from './UpdateLabel'
export { default as UpdateInventoryModal } from './UpdateInventory'
export { default as AddPhotoModal } from './AddPhotoModal'
export { default as VideoDialog } from './VideoDialog'
export { default as ErpWmscodModal } from './ErpWmscodModal'



// WEBPACK FOOTER //
// ./src/views/pms/components/index.js